import loadImage from 'blueimp-load-image';

const utils = {
  getBackUrl(roleName) {
    if (this.isCompany(roleName)) {
      return process.env.VUE_APP_COMPANY_SITE_URL;
    } else if (this.isInfluencer(roleName)) {
      return process.env.VUE_APP_INFLUENCER_SITE_URL;
    }
    return process.env.VUE_APP_SITE_URL;
  },
  getPartnerRoleName(query) {
    if (query === 'c') {
      return 'influencer';
    } else if (query === 'i') {
      return 'company';
    }
  },
  getRoleName(query) {
    if (query === 'c') {
      return 'company';
    } else if (query === 'i') {
      return 'influencer';
    }
  },
  getRoleQuery(query) {
    if (query === 'c' || query === 'i') {
      return query;
    }
  },
  getRoomId(data) {
    if (
      data &&
      data.partnerId &&
      data.projectId &&
      data.roleName &&
      data.userId
    ) {
      let companyId, influencerId;
      if (this.isCompany(data.roleName)) {
        companyId = data.userId;
        influencerId = data.partnerId;
      } else if (this.isInfluencer(data.roleName)) {
        companyId = data.partnerId;
        influencerId = data.userId;
      }
      return `${data.projectId}_${companyId}_${influencerId}`;
    }
  },
  getRoomName(data) {
    if (data && data.projectName && data.partnerName) {
      return `${data.projectName}（${data.partnerName}）`;
    }
  },
  getProjectId(data) {
    return data && data.renewalProjectId;
  },
  getInfluencerId(data) {
    return data && data.influencerId;
  },
  getThumbnail(file, options) {
    if (!file) {
      return;
    }
    options = Object.assign({ canvas: true }, options);
    return new Promise((resolve, reject) => {
      loadImage.parseMetaData(
        file,
        data => {
          if (data.exif) {
            options.orientation = data.exif.get('Orientation');
          }
          loadImage(
            file,
            image => {
              if (image.type === 'error') {
                reject(image);
              } else {
                resolve(image.toDataURL(file.type));
              }
            },
            options
          );
        },
        { meta: true }
      );
    });
  },
  loadImage(src) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = e => reject(e);
      image.src = src;
    });
  },
  isCompany(roleName) {
    if (roleName === 'company') {
      return true;
    }
  },
  isInfluencer(roleName) {
    if (roleName === 'influencer') {
      return true;
    }
  },
  isCreatedRoom(room) {
    // lastDatetimeがnullの場合はまだ代理店権限でルームが作成されていない状態
    if (room && room.lastDatetime) {
      return true;
    }
  },
  isImageType(type) {
    return /^image\//.test(type);
  },
  formatMessageHtml(message) {
    if (!message) {
      return '';
    }
    const escapedMessage = this.escapeHtml(message);
    const urlRegex = /((https?:\/\/|www\.)[^\s<]+)/gi;
    return escapedMessage
      .replace(urlRegex, matchedUrl => {
        const stripped = matchedUrl.replace(/[.,!?;:)\]}、。]+$/u, '');
        const trailing = matchedUrl.slice(stripped.length);
        const href = stripped.startsWith('www.')
          ? `https://${stripped}`
          : stripped;
        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${stripped}</a>${trailing}`;
      })
      .replace(/\n/g, '<br>');
  },
  escapeHtml(value) {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  },
  /**
   * Compare two Firebase-like Timestamps with full precision (seconds + nanoseconds)
   * Uses two-step comparison to avoid integer overflow
   *
   * @param {{ seconds: number, nanoseconds?: number }} a
   * @param {{ seconds: number, nanoseconds?: number }} b
   * @returns {number} Negative if a < b, 0 if equal, positive if a > b
   */
  compareTimestamp(a, b) {
    if (a.seconds !== b.seconds) {
      return a.seconds - b.seconds;
    }
    return (a.nanoseconds || 0) - (b.nanoseconds || 0);
  }
};
export default utils;
